module.exports = __webpack_public_path__ + "img/20220109_103033.7dd2f1fd.jpg";